import React from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const LoadingSpinner = () => {
    const spinnerStyle = {
        animation: 'spin 0.5s linear infinite',
    };

    return (
        <>
            {/* Definir la animación en un estilo dentro del componente */}
            <style>
                {`
                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
                `}
            </style>
            <div className="flex justify-center items-center">
                <AiOutlineLoading3Quarters
                    className="text-rose-500 text-4xl"
                    style={spinnerStyle} // Aplica el estilo al ícono
                />
            </div>
        </>
    );
};

export default LoadingSpinner;
